/**
 * Shared role name parsing (same rules as company user roles UI).
 * @param {string} roleName
 * @returns {{ type: string, module?: string, submodule?: string, action?: string }}
 */
export function parseRoleName(roleName) {
  if (!roleName) return { type: "unknown", module: "unknown" };

  const parts = roleName.split("_");
  if (parts.length === 1) {
    return { type: "main", module: parts[0] };
  }
  if (parts.length === 2) {
    const actions = [
      "read",
      "update",
      "create",
      "delete",
      "approve",
      "reject",
    ];
    if (actions.includes(parts[1])) {
      return { type: "action", module: parts[0], action: parts[1] };
    }
    return { type: "submodule", module: parts[0], submodule: parts[1] };
  }
  if (parts.length === 3) {
    return {
      type: "submodule_action",
      module: parts[0],
      submodule: parts[1],
      action: parts[2],
    };
  }
  return { type: "unknown", module: roleName };
}
